import { GatewayTransitionDTO } from '@ketch-com/figurehead'

export const getDoesTransitionHaveIssues = (transition: GatewayTransitionDTO) => {
  // Statuses can be UNDEFINED ERROR MATCH INVALID UNKNOWN
  // description: 0 - UNDEFINED, 1 - ERROR, 2 - MATCH, 3 - INVALID, 4 - UNKNOWN
  const payload = [1, 3, 4, undefined].includes(transition?.variableStatus)

  return payload
}
